import React, { FC } from 'react'
import { directusFileUrl } from 'src/helpers/directus'

interface IAwardIconProps {
  className?: string
  icon: {
    icon: string
    title: string
  }
}

const AwardIcon: FC<IAwardIconProps> = ({ className, icon }) => (
  <div className={`${className} group cursor-pointer flex flex-col items-center justify-center text-center py-2 select-none`}>
    <div className="h-[168px] md:h-36 flex items-center justify-center">
      <img
        src={directusFileUrl(icon.icon)}
        alt={icon.title}
        className="max-h-36 md:max-h-32 w-auto max-w-[240px] md:max-w-[200px] object-contain inline-block transition-transform duration-500 ease-out group-hover:scale-110 will-change-transform pointer-events-none select-none"
      />
    </div>
  </div>
)

AwardIcon.defaultProps = {
  className: '',
}

export default AwardIcon
